module.exports = __webpack_public_path__ + "cd0510728b7434fad81326ff7c8282f5.woff2";